import classnames from 'classnames';
import ReactDOM from 'react-dom';
import useDropdown from './useDropdown';

import './styles/DropdownContent.scss';

export function DropdownContent({
    children, className
}) {
    const {
        containerRef,
        settings,
        position,
        isOpen,
        hide,
        show
    } = useDropdown();
    const { hasMouseMoveEvents } = settings;
    const conditionalProps = {};

    if (!isOpen || children.length === 0) {
        return null;
    }

    if (hasMouseMoveEvents) {
        conditionalProps.onMouseEnter = show;

        conditionalProps.onMouseLeave = (event) => {
            hide(event, true);
        };
    }

    return ReactDOM.createPortal(
        (
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
            <div
                className={classnames('dropdown-content', className)}
                style={position}
                onClick={hide}
                {...conditionalProps}
            >
                {children}
            </div>
        ),
        containerRef.current
    );
}
